/**
 * Prefer the last open/active chart, then highest chart number.
 * Within a chart, prefer the latest Active episode, else highest episode number.
 */
const OPEN_CHART_STATUSES = new Set(["PreAdmit", "Admit", "Active", "Hold"]);

const isOpenChart = (chart) =>
  OPEN_CHART_STATUSES.has(String(chart?.status || "")) ||
  chart?.isActive === true;

const sortByNumberDesc = (a, b, key) => (b?.[key] || 0) - (a?.[key] || 0);

const pickChart = (charts) => {
  if (!Array.isArray(charts) || !charts.length) return null;
  const sorted = [...charts].sort((a, b) =>
    sortByNumberDesc(a, b, "chartNumber"),
  );
  const open = sorted.filter(isOpenChart);
  return open[0] || sorted[0] || null;
};

const pickEpisode = (chart) => {
  const list = chart?.episodes || [];
  if (!Array.isArray(list) || !list.length) return null;
  const sorted = [...list].sort((a, b) =>
    sortByNumberDesc(a, b, "episodeNumber"),
  );
  const active = sorted.find(
    (ep) => String(ep?.status || "").toLowerCase() === "active",
  );
  return active || sorted[0] || null;
};

/**
 * Build path to a patient's preferred chart + episode workspace.
 * Falls back to the charts hub when none exist.
 *
 * @param {string|number} patientId
 * @param {{ charts?: Array<object> }|null|undefined} chartsPayload
 * @returns {string}
 */
export const resolveLatestEpisodePath = (patientId, chartsPayload) => {
  const charts = chartsPayload?.charts || [];
  const chart = pickChart(charts);
  const episode = pickEpisode(chart);
  if (!chart?.id || !episode?.id) {
    return `/patients/${patientId}/charts`;
  }
  return `/patients/${patientId}/charts/${chart.id}/episodes/${episode.id}`;
};

export const __testables = {
  isOpenChart,
  pickChart,
  pickEpisode,
  OPEN_CHART_STATUSES,
};

export default resolveLatestEpisodePath;
